import styled from 'styled-components';

export const WrapperTruckerRefundable = styled.div`
  margin-top: ${({ theme }) => theme.spacing.km3};

  fuel-table {
    .trow-item-avatar {
      max-width: 44px;
      padding: ${({ theme }) => theme.padding.km0};
    }

    .trow-item-date-paidAt {
      div {
        padding: ${({ theme }) =>
          `${theme.padding.km3} ${theme.padding.km3} ${theme.padding.km3} ${theme.padding.km1}`};
      }
    }
  }
`;

export const ContentTrowScroll = styled.div`
  overflow-y: auto;
`;
